import PostData from "../../packs_helper/scripts/PostData";

const buyButtons = document.querySelectorAll('.package-buy button');
buyButtons.forEach(function(buyButton){
    buyButton.addEventListener('click', BuyPackage);
});

const infoAreas = document.querySelectorAll('.property-name');
infoAreas.forEach(function (infoArea){
    infoArea.addEventListener('mouseover', ShowInfo);
    infoArea.addEventListener('mouseout', ShowInfo);
});

function ShowInfo(e){
    e.preventDefault();
    document.getElementById(this.id + "_info").classList.toggle('active');
}

function BuyPackage(e){
    e.preventDefault();
    ShowPopup({
        title: 'Uyarı',
        message:
            'Paketiniz aktif edilecek ve ücret bakiyenizden düşecektir.<br>' +
            '<strong>* Bu işlem geri alınamaz.</strong>' +
            '<button class="btn btn-default" data-value="0" data-close>Vazgeç</button>' +
            '<button class="btn btn-jungle" data-value="1" data-close>Aktif Et</button>',
    }).then(button => {
        if (button.dataset.value == 1) {
            PostData("/magaza-paketi-satin-al", { package_id: this.id, pre_provision: true })
            .then((response) => {
                if (response.state) {
                    redirect("/magaza-panelim");
                }
            })
            .catch((err) => {});
        }
    })
}

document.addEventListener("click", function(e){
    if(e.target && e.target.id === "buy_confirm"){
        ConfirmPackage(e.target.title);
    }
});

function ConfirmPackage(package_id){
    PostData("/magaza-paketi-satin-al", { package_id: package_id, pre_provision: false });
}